export class EntityConstants {
    static readonly Ageing: string = 'AgeingData';
    static readonly Annexure: string = 'AnnexureData';
    static readonly Performance: string = 'PerformanceData';
    static readonly PremiumData: string = 'PremiumData';
    static readonly RenewalClaim: string = 'RenewalClaimData';
    static readonly Sales: string = 'SalesData';
}